import { useEffect, useMemo, useState } from 'react';

import type { HeroFeedItem } from 'src/app/pages/psf/promoteOrShare/pageContext';

type Result = ModelHookResult<{
	items: readonly HeroFeedItem[];
	animateSpeed: number;
	animateDelay: number;
}>;

const ANIMATE_DELAY = 2000;
const ANIMATE_SPEED = 300;

export function useHeroFeed(shareFeed: readonly HeroFeedItem[], animationStartSize: number): Result {
	const [items, setItems] = useState<readonly HeroFeedItem[]>([...shareFeed].reverse().slice(0, animationStartSize));

	useEffect(() => {
		if (items.length >= shareFeed.length) {
			return undefined;
		}

		const timeout = window.setTimeout(() => {
			setItems([...shareFeed].reverse().slice(0, items.length + 1));
		}, ANIMATE_DELAY + ANIMATE_SPEED);
		return () => {
			window.clearTimeout(timeout);
		};
	}, [items, shareFeed]);

	return {
		data: {
			items: useMemo(() => [...items].reverse(), [items]),
			animateSpeed: ANIMATE_SPEED,
			animateDelay: ANIMATE_DELAY,
		},
	};
}
